import type { AreasComarcales, Tenant, TenantRAW } from "@/types/types"

export const normalizeTenantId = (tenant?: Tenant | null) => tenant?.id ?? null
export const getTenantEntityFromRaw = (raw?: TenantRAW | null) => raw?.tenants_id ? (raw.tenants_id as Tenant) : null

export const normalizeAreasComarcales = (value?: Tenant["areas_comarcales"]): AreasComarcales[] =>
  Array.isArray(value) ? value.filter((x): x is AreasComarcales => !!x && typeof x === "object") : []

export const normalizeMunicipios = (value?: Tenant["municipios"]): any[] =>
  Array.isArray(value) ? value.filter((x) => !!x && typeof x === "object") : []

export const normalizeAmbitosIntervencion = ( value?: Tenant["ambitos_intervencion"]): any[] =>
  Array.isArray(value) ? value.filter((x) => !!x && typeof x === "object") : []

export const getAvailableTenantIds = (tenants?: TenantRAW[]) =>
  Array.isArray(tenants) ? tenants.map(getTenantEntityFromRaw).filter((t): t is Tenant => !!t?.id).map((t) => t.id) : []